var map = {
	"./az.json": [
		"5f4e",
		"chunk-2d0d3e38"
	],
	"./be.json": [
		"d174",
		"chunk-2d21d4e0"
	],
	"./en.json": [
		"edd4",
		"chunk-2d230e25"
	],
	"./et.json": [
		"e1db",
		"chunk-2d224ee0"
	],
	"./hy.json": [
		"dfc6",
		"chunk-2d22a12b"
	],
	"./ka.json": [
		"c5cb",
		"chunk-2d217507"
	],
	"./kk.json": [
		"2d0f",
		"chunk-2d0bd91e"
	],
	"./ky.json": [
		"be6e",
		"chunk-2d21af68"
	],
	"./lt.json": [
		"6045",
		"chunk-2d0ce7b1"
	],
	"./lv.json": [
		"f620",
		"chunk-2d22cfc4"
	],
	"./mn.json": [
		"7bf5",
		"chunk-2d0e1dd0"
	],
	"./old_be.json": [
		"881c",
		"chunk-2d0dee48"
	],
	"./ru.json": [
		"7704"
	],
	"./uz.json": [
		"7500",
		"chunk-2d0d6e54"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;